import { useMemo } from "react";
import useCustomerProfiles from "./useCustomerProfiles";

/**
 * Get all customers associated with the particular whitelabel owner
 */

export default function useCustomers(companyId) {
  const { customerProfiles, isCustomerProfilesLoading, fetchCustomerProfiles } =
    useCustomerProfiles(companyId);

  const customers = useMemo(() => {
    if (isCustomerProfilesLoading) {
      return {
        isCustomersLoading: isCustomerProfilesLoading,
        customers: {},
      };
    }

    const _customers = customerProfiles.reduce((acc, customerProfile) => {
      const { firstName, lastName, user } = customerProfile;
      const { userAccessLevel, whitelabelOwner, email, _id } = user;

      return {
        ...acc,
        [_id]: {
          firstName,
          lastName,
          userAccessLevel,
          whitelabelOwner,
          email,
          _id,
        },
      };
    }, {});

    return {
      isCustomersLoading: isCustomerProfilesLoading,
      customers: _customers,
      fetchCustomers: fetchCustomerProfiles
    };
  }, [isCustomerProfilesLoading, customerProfiles, fetchCustomerProfiles]);

  return customers;
}
